import { IAcademicTitle } from "../Interfaces/IAcademicTitle";

export const academicTitleArray: IAcademicTitle[] = [
  { idAcademicTitle: 1, AcademicTitle: "kein" },
  { idAcademicTitle: 2, AcademicTitle: "Dr." },
  { idAcademicTitle: 3, AcademicTitle: "Prof." },
  { idAcademicTitle: 4, AcademicTitle: "Prof. Dr." },
];
